import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "bg-gray-l1 absolute top-0 right-0 flex justify-content-center align-items-center cursor-pointer",
  style: {"height":"26px","width":"26px","border-radius":"0 5px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("i", {
      class: _normalizeClass(["text-white rotate-180", _ctx.icon])
    }, null, 2)
  ]))
}